// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__XEDwj"};